import { VIEWPORTS } from "web/react/constants";
import {
    CookieType,
    ThirdPartyScript,
} from "web/script/analytics/third_party_scripts/third-party-scripts";
import { load as loadGetFeedback } from "web/script/embedded/getfeedback";
import environment from "web/script/modules/environment";
import browser from "web/script/utils/browser";

const GET_FEEDBACK_DESKTOP_FORM_ID = "311e595cf0c8";
const GET_FEEDBACK_MOBILE_FORM_ID = "5439f9b4a522";

export class GetFeedback implements ThirdPartyScript {
    cookieType: CookieType = "analytics" as CookieType;
    loadScript;
    constructor() {
        this.loadScript = environment.getFeature("mg_getfeedback");
    }
    async load(): Promise<void> {
        if (!this.loadScript) {
            return Promise.resolve();
        }
        const isMobile = browser.getViewport() === VIEWPORTS.Mobile;
        return new Promise((resolve) => {
            const getFeedbackFormId = isMobile
                ? GET_FEEDBACK_MOBILE_FORM_ID
                : GET_FEEDBACK_DESKTOP_FORM_ID;
            loadGetFeedback(getFeedbackFormId);
            resolve();
        });
    }
}
